import { AppContext } from '../../../context';
import { Redirect, useParams } from 'react-router-dom';
import Card from '../../../components/Card';
import React, { useContext } from 'react';
import Wrapper from '../../../components/Wrapper';

import '../../NoResults/styles.scss';

const SuperdayNoResultPage: React.FC = () => {
    const { meetIntro, translate } = useContext(AppContext);

    const { hash } = useParams<{ hash: string }>();

    if (!meetIntro) {
        return <Redirect to={`/s/intro/${hash}`} />;
    }

    const BACKGROUND_STYLES = {
        backgroundImage: `url("${meetIntro?.data?.meetBackgroundUrl}")`,
    };
    const logo = meetIntro?.data?.organization?.logoUrl;
    const backgroundImage = meetIntro?.data?.meetBackgroundUrlList[2] ?? meetIntro?.data?.meetBackgroundUrlList[0];

    return (
        <Wrapper loading={meetIntro?.isLoading} backgroundImage={backgroundImage} logo={logo}>
            {meetIntro?.data ? (
                <div className="container" style={BACKGROUND_STYLES}>
                    <Card meetIntro={meetIntro.data} cardTextMessage={translate('noResults:empty')} isError />
                </div>
            ) : (
                <div>{translate('general:loading')}</div>
            )}
        </Wrapper>
    );
};

export default SuperdayNoResultPage;
